/// <reference types="vite/client" />

const env = import.meta.env as Record<string, string | undefined>;
const isBrowser = typeof window !== "undefined";

/** API origin. Local dev: http://localhost:8787 (wrangler dev). Production: https://api.limeshare.org */
export const API_BASE = (env["VITE_API_BASE"] ?? "http://localhost:8787").replace(/\/$/, "");

/** Origin used when building share links and canonical URLs. */
export const PUBLIC_ORIGIN = (env["VITE_PUBLIC_ORIGIN"] || (isBrowser ? window.location.origin : "https://limeshare.org")).replace(/\/$/, "");

/** Cloudflare Turnstile site key. When unset the bot check is skipped (development only). */
export const TURNSTILE_SITE_KEY = env["VITE_TURNSTILE_SITE_KEY"] || undefined;

export const ABUSE_EMAIL = env["VITE_ABUSE_EMAIL"] ?? "abuse@limeshare.org";

/** Files larger than this cannot be decrypted into memory; a streaming sink is required. */
export const MAX_IN_MEMORY_DOWNLOAD = 512 * 1024 * 1024;

export const IS_MOBILE = isBrowser && /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
export const UPLOAD_CONCURRENCY = IS_MOBILE ? 2 : 3;
